"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _configProvider = require("../config-provider/configProvider");
var _icon = _interopRequireDefault(require("../icon"));
var _useUpdateEffect = require("../utils/hooks/useUpdateEffect");
var _useStateWithCallback5 = _interopRequireDefault(require("./useStateWithCallback"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @param callback
 */
var startTransition = function startTransition(callback) {
  requestAnimationFrame(function () {
    callback();
  });
};
var CarouselItem = function CarouselItem(_ref) {
  var index = _ref.index,
    activeIndex = _ref.activeIndex,
    type = _ref.type,
    width = _ref.width,
    height = _ref.height,
    speed = _ref.speed,
    updateHeight = _ref.updateHeight,
    children = _ref.children;
  var _React$useContext = _react.default.useContext(_configProvider.ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls;
  var PREFIX = getPrefixCls('carousel');
  var itemCls = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(PREFIX, "-item"), true), "".concat(PREFIX, "-item-").concat(index - 1), true), "".concat(PREFIX, "-active"), activeIndex === index - 1), "".concat(PREFIX, "-prev-active"), activeIndex === index), "".concat(PREFIX, "-next-active"), activeIndex === index - 2));
  var ref = _react.default.useRef(null);
  _react.default.useEffect(function () {
    if (height) return;
    if (['card', 'fade', 'vertical'].includes(type)) {
      var h = ref.current.clientHeight;
      if (h > 30) {
        updateHeight(h);
      }
    }
  }, [type, height, updateHeight]);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "carousel-item".concat(index - 1),
    ref: ref,
    className: itemCls,
    style: {
      width: type === 'card' ? width * 0.8 : width,
      height: height,
      transitionDuration: "".concat(speed / 1000, "s")
    }
  }, children);
};
var Carousel = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _props$initialIndex = props.initialIndex,
    initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
    _props$autoplay = props.autoplay,
    autoplay = _props$autoplay === void 0 ? true : _props$autoplay,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    style = props.style,
    _props$arrow = props.arrow,
    arrow = _props$arrow === void 0 ? 'always' : _props$arrow,
    _props$indicatorPosit = props.indicatorPosition,
    indicatorPosition = _props$indicatorPosit === void 0 ? 'inside' : _props$indicatorPosit,
    _props$indicatorType = props.indicatorType,
    indicatorType = _props$indicatorType === void 0 ? 'line' : _props$indicatorType,
    _props$type = props.type,
    type = _props$type === void 0 ? 'normal' : _props$type,
    _props$speed = props.speed,
    speed = _props$speed === void 0 ? 600 : _props$speed,
    _props$interval = props.interval,
    interval = _props$interval === void 0 ? 3000 : _props$interval,
    _props$loop = props.loop,
    loop = _props$loop === void 0 ? true : _props$loop,
    _props$showButton = props.showButton,
    showButton = _props$showButton === void 0 ? true : _props$showButton,
    height = props.height,
    onChange = props.onChange;
  /**
   * 当前展示项
   */
  var _React$useState = _react.default.useState(initialIndex || 0),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    activeIndex = _React$useState2[0],
    setActiveIndex = _React$useState2[1];
  /**
   * 走马灯组件的dom引用
   */
  var carouselRef = _react.default.useRef(null);
  /**
   * 走马灯item列表的dom引用
   */
  var itemListRef = _react.default.useRef(null);
  /**
   * autoplay的时间锚
   */
  var timerRef = _react.default.useRef(0);
  /**
   * 是否正在进行动画过渡
   */
  var _useStateWithCallback = (0, _useStateWithCallback5.default)(false),
    _useStateWithCallback2 = (0, _slicedToArray2.default)(_useStateWithCallback, 2),
    isTransition = _useStateWithCallback2[0],
    setIsTransition = _useStateWithCallback2[1];
  /**
   * 容器宽度
   */
  var _useStateWithCallback3 = (0, _useStateWithCallback5.default)(0),
    _useStateWithCallback4 = (0, _slicedToArray2.default)(_useStateWithCallback3, 2),
    width = _useStateWithCallback4[0],
    setWidth = _useStateWithCallback4[1];
  var _React$useState3 = _react.default.useState(height),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    mHeight = _React$useState4[0],
    setMHeight = _React$useState4[1];
  var timeRef = _react.default.useRef(0);
  var children = _react.default.Children.toArray(props.children);
  /**
   * 列表的真实长度
   */
  var len = children.length;
  var _React$useContext2 = _react.default.useContext(_configProvider.ConfigContext),
    getPrefixCls = _React$useContext2.getPrefixCls;
  var PREFIX = getPrefixCls('carousel');
  var stopAutoPlay = function stopAutoPlay() {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = 0;
  };
  /**
   * 只有当传入属性autoplay为true时才会触发mouseenter事件
   */
  var onMouseEnter = (0, _react.useCallback)(function () {
    stopAutoPlay();
  }, []);
  var getTranslateX = function getTranslateX(x) {
    return "translate3d(".concat(x, "px, 0px, 0px)");
  };
  var getTranslateY = function getTranslateY(y) {
    return "translate3d(0px, ".concat(y, "px, 0px)");
  };
  var getTranslate = (0, _react.useCallback)(function (newActiveIndex) {
    var isVertical = type === 'vertical';
    if (isVertical) {
      return getTranslateY(-mHeight * (newActiveIndex + 1));
    }
    return getTranslateX(-width * (newActiveIndex + 1));
  }, [type, width, mHeight]);
  var getNextActiveIndex = (0, _react.useCallback)(function (index, isLoop) {
    if (isLoop) {
      if (index === len) return 0;
      if (index === -1) return len - 1;
      return index;
    }
    if (index === len) return len - 1;
    if (index === -1) return 0;
    return index;
  }, [len]);
  var move = (0, _react.useCallback)(function (num) {
    var temp = activeIndex;
    var itemList = itemListRef.current;
    var newActiveIndex = activeIndex + num;
    var isNormalType = ['normal', 'vertical'].includes(type);
    var realActiveIndex = getNextActiveIndex(newActiveIndex, loop);
    if (!isNormalType) {
      onChange === null || onChange === void 0 || onChange(temp, realActiveIndex);
      setActiveIndex(realActiveIndex);
      return;
    }
    if (!itemList) return;
    if (loop) {
      setActiveIndex(newActiveIndex);
      itemList.style.transform = getTranslate(newActiveIndex);
      var notFirstOrLastIndex = newActiveIndex !== len && newActiveIndex !== -1;
      if (notFirstOrLastIndex) {
        onChange === null || onChange === void 0 || onChange(temp, newActiveIndex);
        return;
      }
      timeRef.current = window.setTimeout(function () {
        onChange === null || onChange === void 0 || onChange(temp, realActiveIndex);
        setIsTransition(false);
        itemList.style.transform = getTranslate(realActiveIndex);
        setTimeout(function () {
          setActiveIndex(realActiveIndex);
          startTransition(function () {
            setIsTransition(true);
          });
        }, 20);
        // 等待translate效果结束
      }, speed);
    } else {
      onChange === null || onChange === void 0 || onChange(temp, realActiveIndex);
      setActiveIndex(realActiveIndex);
      itemList.style.transform = getTranslate(realActiveIndex);
    }
  }, [activeIndex, getNextActiveIndex, getTranslate, len, loop, onChange, speed, type]);
  var next = (0, _react.useCallback)(function () {
    if (activeIndex < len) {
      move(1);
    } else if (!isTransition) {
      move(0);
    }
  }, [activeIndex, isTransition, len, move]);
  var prev = function prev() {
    if (activeIndex > -1) {
      move(-1);
    } else if (!isTransition) {
      move(0);
    }
  };
  var setActiveItem = (0, _react.useCallback)(function (index) {
    move(index - activeIndex);
  }, [activeIndex, move]);
  var autoplayHandler = (0, _react.useCallback)(function () {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(function () {
      next();
      autoplayHandler();
    }, interval);
  }, [next, interval]);
  /**
   * 只有当传入属性autoplay为true时才会触发mouseleave事件
   */
  var onMouseLeave = (0, _react.useCallback)(function () {
    autoplayHandler();
  }, [autoplayHandler]);
  var setCarouselWidth = function setCarouselWidth(w, callback) {
    setWidth(w, callback);
  };
  var onWindowResized = (0, _react.useCallback)(function () {
    var _carouselRef$current;
    var outer = (_carouselRef$current = carouselRef.current) === null || _carouselRef$current === void 0 ? void 0 : _carouselRef$current.querySelector(".".concat(PREFIX, "-itemList-outer"));
    // 获取容器宽度，容器为100%,拿到真实宽度后渲染children的宽度
    var offsetWidth = outer && outer.clientWidth || 0;
    /**
     *  this.setState({ width }, () => {
     *  this.setState({ isTransition: false }, () => {
     *    setTimeout(() => {
     *      this.setActiveItem(activeIndex);
     *      setTimeout(() => {
     *        this.setState({ isTransition: true });
     *      }, 0);
     *    }, this.speed); // 在过渡期间resize要等过渡结束再切换
     *  });
     * });
     */
    setCarouselWidth(offsetWidth, function () {
      setIsTransition(false, function () {
        setTimeout(function () {
          setActiveItem(activeIndex);
          setTimeout(function () {
            setIsTransition(true);
          }, 0);
          // 在过渡期间resize要等过渡结束再切换
        }, speed);
      });
    });
  }, [PREFIX, activeIndex, setActiveItem, speed]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      next: next,
      prev: prev,
      setActiveItem: setActiveItem,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      setWidth: setCarouselWidth
    };
  });
  (0, _react.useEffect)(function () {
    if (autoplay) {
      autoplayHandler();
    }
    // 清理定时器
    return function () {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [autoplay, autoplayHandler]);
  (0, _react.useEffect)(function () {
    var carousel = carouselRef.current;
    var outer = carousel === null || carousel === void 0 ? void 0 : carousel.querySelector(".".concat(PREFIX, "-itemList-outer"));
    // 获取容器宽度，容器为100%,拿到真实宽度后渲染children的宽度
    var offsetWidth = outer && outer.clientWidth || 0;
    if (offsetWidth !== width) {
      requestAnimationFrame(function () {
        setCarouselWidth(offsetWidth);
      });
    }
  }, [PREFIX, width]);
  (0, _react.useEffect)(function () {
    if (!width) return;
    setActiveItem(activeIndex);
    timeRef.current = window.setTimeout(function () {
      setIsTransition(true);
    }, 100);
    return function () {
      clearTimeout(timeRef.current);
    };
  }, [width]);
  (0, _react.useEffect)(function () {
    var carousel = carouselRef.current;
    // 当页面宽度改变时，更新width属性
    window.addEventListener('resize', onWindowResized);
    if (autoplay && carousel) {
      // 鼠标进入container时，暂停autoplay
      carousel.addEventListener('mouseenter', onMouseEnter);
      // 鼠标离开container时，继续autoplay
      carousel.addEventListener('mouseleave', onMouseLeave);
    }
    return function () {
      window.removeEventListener('resize', onWindowResized);
      if (autoplay && carousel) {
        carousel.removeEventListener('mouseleave', onMouseLeave);
      }
    };
  }, [autoplay, onWindowResized, onMouseEnter, onMouseLeave]);
  (0, _useUpdateEffect.useUpdateEffect)(function () {
    if (autoplay) {
      autoplayHandler();
    } else {
      stopAutoPlay();
    }
  }, [autoplay]);
  var updateHeight = _react.default.useCallback(function (h) {
    setMHeight(h);
  }, []);
  var rootCls = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, PREFIX, true), "".concat(PREFIX, "-").concat(type), true), "".concat(PREFIX, "-wrapper-").concat(indicatorPosition), indicatorPosition.includes('outside')));
  if (width === 0) return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(rootCls, " ").concat(className),
    style: style,
    ref: carouselRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-itemList-outer")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-itemList")
  })));
  // 前后各添加一个，实现循环滚动
  var renderChildren = [children[len - 1]].concat((0, _toConsumableArray2.default)(children), [children[0]]);
  var renderLen = renderChildren.length;
  var liList = Array.from(new Array(len), function (_, index) {
    return index;
  });
  var itemListStyle = isTransition ? {
    transition: "transform ".concat(speed / 1000, "s ease-in-out")
  } : {};
  if (type === 'normal') {
    itemListStyle.width = "".concat(renderLen * width, "px");
  }
  var renderButton = function renderButton() {
    if (showButton && len > 1) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "".concat(PREFIX, "-btn ").concat(PREFIX, "-prev  ").concat(PREFIX, "-").concat(arrow),
        onClick: function onClick() {
          prev();
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "left-thick"
      })), /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        className: "".concat(PREFIX, "-btn ").concat(PREFIX, "-next ").concat(PREFIX, "-").concat(arrow),
        onClick: function onClick() {
          next();
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        type: "right-thick"
      })));
    }
    return null;
  };
  var renderIndicatorPosition = function renderIndicatorPosition() {
    if (indicatorPosition === 'none') return null;
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: "".concat(PREFIX, "-indicator ").concat(PREFIX, "-").concat(indicatorPosition, " ").concat(PREFIX, "-").concat(indicatorType)
    }, liList.map(function (i) {
      var flag;
      if (activeIndex === len) {
        flag = 0;
      } else if (activeIndex === -1) {
        flag = len - 1;
      } else {
        flag = activeIndex;
      }
      var dotCls = (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(PREFIX, "-dot"), true), "".concat(PREFIX, "-active-dot"), flag === i));
      return /*#__PURE__*/_react.default.createElement("span", {
        key: "carousel-li-".concat(i),
        className: dotCls,
        onClick: function onClick() {
          setActiveItem(i);
        }
      });
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(rootCls, " ").concat(className),
    style: style,
    ref: carouselRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-itemList-outer"),
    style: {
      height: mHeight
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(PREFIX, "-itemList"),
    style: itemListStyle,
    ref: itemListRef
  }, renderChildren.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement(CarouselItem, {
      key: "carousel-item".concat(i - 1),
      index: i,
      activeIndex: activeIndex,
      type: type,
      width: width,
      height: mHeight,
      speed: speed,
      updateHeight: updateHeight
    }, item);
  })), renderButton()), renderIndicatorPosition());
});
Carousel.displayName = 'Carousel';
var _default = exports.default = Carousel;